// extracted by mini-css-extract-plugin
export default {"root":"YNV5l","delay":"K8JoC","resend":"Y2lWp","buttons":"FVOXn"};